import React from 'react';

export default class UPLUSLogo extends React.Component {
  render() {

    const styles = {
      st0: { fill: '#00459B' },
      st1: { fill: '#B81C22' },
      st2: { fill: '#0068B6' },
    };
    return (<div className="logo">

      <svg width="500px" height="185px" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1920 1080">
       
      <g>
      <g>
        <path style={styles.st0} d="M501.1,699.5h-6.4c-0.7-1.7-1-3.2-1-4.7c0-1.1,0.3-1.8,0.8-2.3c0.6-0.5,1.4-0.7,2.5-0.7h26
          c0.6,1.4,1,2.8,1,4.2c0,1.4-0.2,2.3-0.7,2.8c-0.5,0.5-1.3,0.8-2.3,0.8h-4.3c-0.2,4.8-0.3,16.1-0.2,33.7c0,14.3-2.8,24-8.4,29.1
          c-5.6,5.1-14,7.7-25,7.7c-10,0-16.9-1.9-20.7-5.6c-3.8-3.7-5.7-10.6-5.7-20.6c0-24.7-0.1-39.5-0.3-44.3h-5.3c-0.6-1.7-1-3.2-1-4.7
          c0-1.1,0.3-1.8,0.8-2.3c0.5-0.5,1.4-0.7,2.5-0.7h27c0.6,1.4,1,2.8,1,4.2c0,1.4-0.2,2.3-0.7,2.8c-0.5,0.5-1.3,0.8-2.3,0.8h-3.8
          c-0.2,5-0.3,15.9-0.3,32.8c0,11,1.1,18.2,3.3,21.7c2.2,3.4,5.7,5.2,10.5,5.2c5,0,8.6-1.5,10.6-4.6c2.1-3.1,3.1-9.1,3.1-18.2
          C501.4,716.7,501.3,704.4,501.1,699.5z"/>
        <path style={styles.st0} d="M547.3,699.5h-7.5c-0.6-1.7-1-3.2-1-4.7c0-1.1,0.3-1.8,0.8-2.3c0.5-0.5,1.4-0.7,2.5-0.7h27.2
          c14.6,0,24.4,1.8,29.5,5.3c5,3.5,7.6,9.3,7.6,17.4c0,8.3-3.1,14.8-9.1,19.5c-6.1,4.7-15.9,7.1-29.4,7.1h-2.7
          c0,9.8,0.1,16.5,0.3,20.1h9.3c0.6,1.4,1,2.7,1,4.2c0,1.3-0.2,2.2-0.7,2.8c-0.5,0.5-1.3,0.8-2.4,0.8h-32.8c-0.7-1.7-1-3.3-1-4.8
          c0-1,0.3-1.8,0.8-2.2c0.6-0.5,1.4-0.7,2.5-0.7h5.3c0.2-4.8,0.3-17.4,0.3-37.8C547.6,712.2,547.5,704.3,547.3,699.5z M570.1,731.8
          c5.8,0,10.1-1,12.8-3.1c2.7-2.1,4.1-5.7,4.1-10.8c0-4.9-1.3-8.6-3.9-11.3c-2.6-2.7-6.6-4-12-4c-2.3,0-4.2,0.2-5.7,0.6
          c-0.2,2.4-0.3,9.1-0.3,20.2v8.5H570.1z"/>
        <path style={styles.st0} d="M639.5,759.4h1.4c12.6,0,22.6-1.5,30-4.5c1.7,2.5,2.5,5.2,2.5,8.1c0,2.1-0.8,3.6-2.3,4.5
          c-1.5,0.9-4.7,1.4-9.4,1.4l-46.8,0.1c-0.7-1.7-1-3.3-1-4.8c0-1,0.3-1.8,0.8-2.2c0.6-0.5,1.4-0.7,2.5-0.7h4.1
          c0.2-4.9,0.3-17.5,0.3-37.9c0-11-0.1-19-0.4-23.8h-6.4c-0.7-1.7-1-3.2-1-4.7c0-1.1,0.3-1.8,0.8-2.3c0.6-0.5,1.4-0.7,2.5-0.7H647
          c0.6,1.4,1,2.8,1,4.2c0,1.4-0.2,2.3-0.7,2.8c-0.5,0.5-1.3,0.8-2.3,0.8h-5.5c-0.2,4.8-0.3,12.8-0.3,23.8
          C639.1,743.7,639.3,755.7,639.5,759.4z"/>
        <path style={styles.st0} d="M729.8,699.5h-6.4c-0.7-1.7-1-3.2-1-4.7c0-1.1,0.3-1.8,0.8-2.3c0.6-0.5,1.4-0.7,2.5-0.7h26
          c0.6,1.4,1,2.8,1,4.2c0,1.4-0.2,2.3-0.7,2.8c-0.5,0.5-1.3,0.8-2.3,0.8h-4.3c-0.2,4.8-0.3,16.1-0.2,33.7c0,14.3-2.8,24-8.4,29.1
          c-5.6,5.1-14,7.7-25,7.7c-10,0-16.9-1.9-20.7-5.6c-3.8-3.7-5.7-10.6-5.7-20.6c0-24.7-0.1-39.5-0.3-44.3h-5.3c-0.6-1.7-1-3.2-1-4.7
          c0-1.1,0.3-1.8,0.8-2.3c0.5-0.5,1.4-0.7,2.5-0.7h27c0.6,1.4,1,2.8,1,4.2c0,1.4-0.2,2.3-0.7,2.8c-0.5,0.5-1.3,0.8-2.3,0.8h-3.8
          c-0.2,5-0.3,15.9-0.3,32.8c0,11,1.1,18.2,3.3,21.7c2.2,3.4,5.7,5.2,10.5,5.2c5,0,8.6-1.5,10.6-4.6c2.1-3.1,3.1-9.1,3.1-18.2
          C730.1,716.7,730,704.4,729.8,699.5z"/>
        <path style={styles.st0} d="M791.4,690.6c9.7,0,16.1,0.6,19.2,1.7c3.1,1.1,4.7,3.3,4.7,6.6c0,3.1-1.1,5.9-3.4,8.4
          c-8.7-3.9-16.2-5.9-22.6-5.9c-4.3,0-7.2,0.7-8.9,2.2c-1.7,1.5-2.5,3.6-2.5,6.4c0,3.3,1,5.8,3.1,7.4c2.1,1.6,6.2,3.4,12.5,5.2
          c7.9,2.1,14,4.7,18.3,7.8c4.3,3.2,6.5,8.3,6.7,15.5c0,8.1-2.9,14.2-8.8,18.1c-5.9,3.9-14.4,5.9-25.6,5.9c-8.1,0-14.1-0.6-18-1.8
          c-3.9-1.2-5.8-3.6-5.8-7.2c0-3.2,1.3-6,4-8.4c8.6,4.4,16.7,6.6,24.2,6.6c4.9,0,8.4-0.6,10.3-1.9c2-1.3,2.9-3.5,2.9-6.5
          c0-3.5-1.5-6.3-4.6-8.2c-3.1-2-8.1-3.9-15.1-5.9c-7.5-2-12.8-4.8-16.1-8.3c-3.3-3.5-4.9-8.1-4.9-13.6c0-7.6,2.7-13.5,8-17.7
          C774.6,692.7,782,690.6,791.4,690.6z"/>
        <g>
          <g>
            <g>
              <path style={styles.st0} d="M923.1,769.4h-23.9l-0.4-1.1c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.2-3c0.7-0.7,1.7-1,3.1-1h0.8
                c-0.8-3.3-2.3-8.5-4.4-15.2h-22.1c-1.9,6.8-3.2,11.9-3.8,15.2h4.2l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8c0,1.4-0.3,2.4-1.1,3.1
                c-0.7,0.7-1.7,1.1-3.1,1.1h-21.4l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.7-1,3.1-1h2
                c2.4-6.8,6.3-18.5,11.6-34.8c5.7-17.6,9.1-27.5,10.5-30.2c1.6-3.3,4.6-4.9,8.7-4.9c6.1,0,7.2,0.3,7.9,0.7
                c0.8,0.5,1.4,0.8,11.9,31.6c6.4,18.8,10.9,31.5,13.4,37.7h4.8l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8c0,1.4-0.3,2.4-1.1,3.1
                C925.6,769.1,924.5,769.4,923.1,769.4z M879.4,734.5h16c-4.5-14.4-7-21.7-8.3-25.4C885.8,712.8,883.6,720.1,879.4,734.5z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M960.4,770.5c-11,0-19.2-2.7-24.6-8c-5.3-5.3-8-14.8-8-28.3c0-14.9,3.1-26.1,9.2-33.3
                c6.2-7.2,15.4-10.9,27.3-10.9c6.5,0,11.5,0.5,14.9,1.6c5,1.6,6.1,4.6,6.1,6.9c0,2.5-1.2,4.9-3.5,7.2l-0.9,0.9l-1.1-0.5
                c-6.3-3-12.4-4.5-18.1-4.5c-5.7,0-9.8,2-12.6,6c-2.9,4.2-4.4,11.5-4.4,21.7c0,11.4,1.6,19.3,4.6,23.6c2.9,4.1,7.9,6.2,14.7,6.2
                c6.1,0,11.7-1.6,16.6-4.8l1.2-0.8l1,1c2.3,2.3,3.4,4.9,3.4,7.5c0,3-2.7,5.1-8.4,6.6C973,769.9,967.1,770.5,960.4,770.5z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M1060.5,769.4h-23.9l-0.4-1.1c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.7-1,3.1-1h0.8
                c-0.8-3.3-2.3-8.4-4.4-15.2h-22.1c-1.9,6.8-3.2,11.9-3.8,15.2h4.2l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8c0,1.4-0.3,2.4-1.1,3.1
                c-0.7,0.7-1.7,1.1-3.1,1.1h-21.4l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.7-1,3.1-1h2
                c2.4-6.8,6.3-18.5,11.6-34.8c5.7-17.6,9.1-27.5,10.5-30.2c1.6-3.3,4.6-4.9,8.7-4.9c6.1,0,7.2,0.3,7.9,0.7
                c0.8,0.5,1.4,0.8,11.9,31.6c6.4,18.8,10.9,31.5,13.4,37.7h4.8l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8c0,1.4-0.3,2.4-1.1,3.1
                C1063,769.1,1061.9,769.4,1060.5,769.4z M1016.8,734.5h16c-4.6-14.4-7-21.7-8.3-25.4C1023.2,712.8,1021,720.1,1016.8,734.5z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M1068.8,769.5l-0.4-1.1c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.2,0.4-2.2,1.2-2.9c0.7-0.7,1.7-1,3.1-1h2.4
                c0.2-6,0.3-18.5,0.3-37.4c0-9.9-0.1-17.6-0.3-22.7h-5.3l-0.4-1.1c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.2-3
                c0.7-0.7,1.7-1,3.1-1h22.1c15.1,0,25.8,2.8,31.7,8.4c6,5.6,9,14.8,9,27.3c0,13.9-3,24.6-9,31.7c-6,7.2-16,10.9-29.5,10.9
                L1068.8,769.5z M1090.5,702.9c-0.2,6.2-0.3,19.4-0.3,39.1c0,12.4,0.9,14.3,1.1,14.6c0,0,1,1.3,8.5,1.3c6,0,10.6-1.8,13.5-5.4
                c3-3.7,4.5-10.9,4.5-21.4c0-10.8-1.8-18.3-5.3-22.4c-3.5-4-9-6-16.5-6C1093.9,702.6,1092,702.7,1090.5,702.9z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M1144.2,769.5l-0.4-1.1c-0.5-1.4-0.8-2.8-0.8-4.1c0-1.2,0.4-2.2,1.2-2.9c0.7-0.7,1.7-1,3.1-1h2.4
                c0.2-6,0.3-18.5,0.3-37.4c0-10-0.1-17.6-0.3-22.7h-5.3l-0.4-1.1c-0.5-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.2-3
                c0.7-0.7,1.7-1,3.1-1h46.9c2.5,0,4.2,0.4,5.3,1.2c1.2,0.9,1.8,2.5,1.8,4.9c0,2.5-0.8,5.2-2.3,7.8l-0.8,1.3l-1.4-0.6
                c-6.7-2.7-16-4.1-27.8-4.1h-3.1c-0.2,4.2-0.3,11.3-0.2,21.1h28.2l0.4,1.2c0.5,1.6,0.8,3.3,0.8,5c0,1.5-0.4,2.6-1.1,3.3
                c-0.7,0.7-1.8,1-3.3,1h-25c0,12.7,0.1,21.2,0.3,25.5h6c11.4,0,20.4-1.3,26.8-3.7l1.4-0.5l0.7,1.3c1.3,2.3,2,4.7,2,7.1
                c0,2.2-0.8,3.9-2.3,5c-1.4,1-3.8,1.4-7.5,1.4L1144.2,769.5z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M1292,769.4h-22.7l-0.4-1.1c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.7-1,3.1-1h1.5
                c0.2-6.5,0.1-21.3-0.2-43.9c-2,7.2-4.3,14.4-6.7,21.7c-3.9,11.8-6.3,18.3-7.5,20.5c-1.5,2.6-4,4-7.4,4c-5.8,0-6.8-0.3-7.4-0.7
                c-0.7-0.5-1.2-0.8-8-20c-3-8.5-5.8-17-8.3-25.6c0,22.7,0,37.5,0.2,44h4.6l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8
                c0,1.4-0.3,2.4-1.1,3.2c-0.7,0.7-1.7,1.1-3.1,1.1h-21.4l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4c0-1.3,0.4-2.3,1.1-3
                c0.7-0.7,1.7-1,3.1-1h2.4c0.4-5.5,0.7-15.2,1-28.8c0.3-13.9,0.5-24.4,0.4-31.2h-5l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4
                c0-1.3,0.4-2.3,1.2-3c0.7-0.7,1.7-1,3.1-1h23.8l0.4,1.3c1.8,6.3,4.2,14.5,7.3,24.1c3.1,9.8,5.6,17.9,7.4,24
                c0.5,1.8,0.9,3.3,1.3,4.5c1-3.2,2.7-8.9,5.7-18.9c4.6-15.7,7.7-27.1,9.3-33.8l0.3-1.4h24.8l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8
                c0,1.4-0.3,2.4-1.1,3.1c-0.7,0.7-1.7,1.1-3.1,1.1h-1.9c-0.1,6.8,0,17.2,0.4,31.2c0.3,13.6,0.7,23.3,1,28.8h4.8l0.5,1.1
                c0.6,1.3,0.9,2.6,0.9,3.9c0,1.4-0.3,2.4-1.1,3.1C1294.5,769.1,1293.5,769.4,1292,769.4z"/>
            </g>
          </g>
          <g>
            <g>
              <path style={styles.st0} d="M1348.6,769.4h-28.3l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4c0-1.3,0.4-2.3,1.1-3c0.7-0.7,1.7-1,3.1-1h4.4
                c0.2-4.6,0.3-9.8,0.3-15.5c-11.3-22.7-19-37.7-22.8-44.5h-4.5l-0.4-1.2c-0.5-1.4-0.8-2.8-0.8-4c0-1.3,0.4-2.3,1.1-3
                c0.7-0.7,1.7-1,3.1-1h23.3l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8c0,1.4-0.3,2.4-1.1,3.1c-0.7,0.7-1.7,1.1-3.1,1.1h-0.3
                c1.7,4.7,4.4,11.3,8,19.7c2.8,6.5,4.5,10.1,5.4,12c0.9-1.9,2.3-5.4,4.8-11.6c3.3-8.3,5.7-15.1,7.2-20.2h-3.7l-0.4-1.1
                c-0.6-1.4-0.8-2.8-0.8-4.1c0-1.3,0.4-2.3,1.2-3c0.7-0.7,1.7-1,3.1-1h21.1l0.4,1.1c0.5,1.3,0.8,2.6,0.8,3.8
                c0,1.4-0.3,2.4-1.1,3.1c-0.7,0.7-1.7,1.1-3.2,1.1h-1.5c-3.8,7.2-11,21.8-21.3,43.4c0,6.4,0.1,12,0.3,16.6h7.6l0.5,1.1
                c0.6,1.3,0.9,2.6,0.9,3.9c0,1.4-0.3,2.4-1.1,3.1C1351.1,769.1,1350.1,769.4,1348.6,769.4z"/>
            </g>
          </g>
        </g>
        <g>
          <path style={styles.st0} d="M1393.5,683.5c0-13.5,9.8-22.9,21.8-22.9c11.8,0,21.8,9.4,21.8,22.9c0,13.7-9.9,22.8-21.8,22.8
            C1403.3,706.3,1393.5,697.2,1393.5,683.5z M1432.6,683.5c0-11-7.6-18.9-17.4-18.9c-9.8,0-17.5,7.9-17.5,18.9
            c0,11.1,7.6,18.9,17.5,18.9C1425,702.5,1432.6,694.6,1432.6,683.5z M1406.9,671.3h8.7c4.7,0,9,2,9,7.6c0,2.8-1.8,5.5-4.4,6.4
            l5.4,9.8h-5l-4.3-8.4h-4.9v8.4h-4.5V671.3z M1414.5,683.2c3.2,0,5.2-1.3,5.2-4c0-2.4-1.3-4.1-4.9-4.1h-3.4v8.1H1414.5z"/>
        </g>
      </g>
      <g>
        <path style={styles.st1} d="M1062.8,298.9v185.6c0,24.5-25.2,55.6-71,87.6c-27.2,19-54.9,33.5-68.8,40.4c-13.8-6.8-41.1-21.1-68.3-40.1
          c-46.1-32.1-71.5-63.4-71.5-88V298.9H1062.8L1062.8,298.9z M1085.3,276.4H760.6v208.1c0,79.9,162.4,152.9,162.4,152.9
          s162.3-73.1,162.3-152.9V276.4L1085.3,276.4z"/>
        <rect x="961.9" y="332.9" style={styles.st2} width="54.1" height="79.8"/>
        <path style={styles.st0} d="M961.5,469.8c0,20.7-6.7,45.4-38.5,45.4s-38.5-24.7-38.5-45.4v-71.9v-65h-54.6v65v73.9
          c0,59.2,34.8,94.5,93.1,94.5c58.3,0,93.1-35.3,93.1-94.5v-40.4h-54.6V469.8z"/>
        <polygon style={styles.st2} points="1037.5,400.8 1037.5,354.8 939.8,354.8 939.8,400.8 961.5,400.8 961.5,418.3 1016.1,418.3 
          1016.1,400.8 		"/>
      </g>
    </g>
        </svg>
    </div>);
  }

}



// WEBPACK FOOTER //
// ./src/components/svglogos/LoginLogo/UPLUSLogo.js